import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Modal from '../Modal';

const propTypes = {
  user: PropTypes.object
}

class FlaggedUserModal extends Component {
  render() {
    const { user } = this.props;
    const activeFlags = user.flags.filter( flag => flag.active == true)
    const show = activeFlags.length > 0 ? true : false;

    return show && (
        <Modal.Body className="container px-0">
          <div className="alert alert-danger text-center">
            <h4>This user has <u>{activeFlags.length}</u> active flags:</h4>
            <div className="center-text">
              <ul style={{ listStyle: 'inside' }}>
                {user.flags.map((flag) => (
                  (flag.active == true) && <li>{flag.reason}</li>
                ))}
              </ul>
            </div>
          </div>
        </Modal.Body>
    );
  }
}

export default (FlaggedUserModal)
